import React from "react";
import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

const PO28Button11Icon = (props: SvgIconProps) => (
  <SvgIcon fillRule="evenodd" clipRule="evenodd" color="secondary" fontSize="small" {...props}>
    <path d="M0 0H3V4H4V7H3H0V4V0ZM5 2H11V9H5V2ZM5 11H11V19H5V11ZM13 0H16V4V7H13H12V4H13V0Z" />
  </SvgIcon>
);

export default PO28Button11Icon;
